import { Component, OnInit } from "@angular/core";
import { ServiceNowPairingBaseComponent } from "./svcnow-pairing-base.component";

@Component({
    templateUrl: './svcnow-pairing.component.html',
    styleUrls: ['../svcnow.style.css', './svcnow-pairing.component.css'],
    standalone: false
})
export class ServiceNowPairingComponent extends ServiceNowPairingBaseComponent implements OnInit {
    TAG: string = 'RoomPair';
}